<template>
  <div class="report-notice">
    <div class="content">
      <span>
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-a-warring-tianchong3"></use>
        </svg>
      </span>

      <div>
        <p>{{ $t('seller.accBonusProgram.creact.noticeDuplicateCommission') }}</p>
      </div>
    </div>
  </div>
</template>
<script setup>
  
const props = defineProps({
  currentStep: {
    type: Number,
    default: 0
  }
})
</script>
<style lang="less" scoped>
.report-notice {
  padding-bottom: 16px;
  .content {
    position: relative;
    display: flex;
    padding: 12px 16px;
    background-color: var(--yellow-bg);
    border-radius: 8px;
    border: 2px solid var(--yellow-5);

    > span {
      display: flex;
      width: 20px;
      height: 20px;
      border-radius: 10px;
      box-shadow: 0 0 0 3px var(--yellow-icon-bg);
      justify-content: center;
      margin-right: 8px;
      margin-top: 4px;
      svg {
        width: 22px;
        min-width: 22px;
        height: 22px;
        fill: var(--yellow-7);
        align-self: center;
      }
    }
    p {
      font-family: Sora;
      font-weight: 400;
      font-style: Regular;
      font-size: 14px;
      leading-trim: NONE;
      line-height: 24px;
      letter-spacing: 0.5px;
      color: rgba(0, 0, 0, 1);
    }
    .close-icon {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 20px;
      height: 20px;
      fill: var(--dark-4);
      cursor: pointer;
    }
  }
}
</style>
